import { formatDate } from '@angular/common';
import { SkyClubCard } from '@com-delta-idp/mnx-skymiles-overview-ui';
import { UserSession } from '@com-delta-idp/mnx-skymiles-shared';
import {
  SkyClubTrackerConstant as Constant,
  SkyClubResponse,
  VisitRecord
} from '../models';
import { VisitSpend } from '../models/aem/visit-spend.interface';
import { DscSpendTracker } from '../models/api/tracker-details.interfaces';
import { StatusTrackerResponse } from '../models/api/tracker.interfaces';
import {
  getImageObj,
  getSpendTracker,
  sortCards
} from '../utils/amex-skyclub-helper.utils';
import { getVisit } from '../utils/amex-skyclub-tracker.utils';
import { checkSkyClub } from './amex-skyclub-tracker.adapter';

export const getCards = (
  aem: VisitSpend,
  skyClub: SkyClubResponse,
  trackerContent: StatusTrackerResponse,
  profile: UserSession
): SkyClubCard[] => {
  const cards: SkyClubCard[] = [];
  if (checkSkyClub(trackerContent, skyClub)) {
    skyClub.visitRecord.forEach((record) => {
      const trackerInfo = getTrackerInfo(trackerContent, record);
      if (trackerInfo !== undefined) {
        const thresholdMet = getThresholdMet(trackerInfo);
        const innerSpendTracker = {
          spendTracker: {
            ...thresholdMet,
            ...getSpendTracker(aem, trackerInfo)
          }
        };
        const innerRecords = {
          visit: getVisit(aem, record, trackerInfo),
          type: {
            name: getVisitName(aem, record),
            terms: {
              isIcon: true,
              label: '',
              url: '',
              information: aem.cardTooltipInfo
            }
          },
          ...innerSpendTracker,
          ...thresholdMet
        };
        cards.push(innerRecords);
      }
    });

    sortCards(cards);
  }

  if (isValidSkyClubMember(profile)) {
    cards.unshift({
      visit: {
        maxCount: 15,
        title: aem.unlimited.title,
        description: getDescription(aem, profile),
        image: getImageObj(aem.cardImages, Constant.UNLIMITED_MEMBERSHIP)
      },
      type: {
        name: aem.skyClubMembershipLabel,
        terms: {
          isIcon: false,
          label: aem.termsLabel,
          url: aem.termsUrl,
          information: ''
        }
      },
      searchEligibleFooter: {
        image: {
          src: aem.searchImgSrc,
          alt: aem.searchImgAlt
        },
        label: aem.searchlabel,
        url: aem.searchUrl
      }
    });
  }

  return cards;
};

export const getThresholdMet = (trackerInfo: DscSpendTracker) => {
  return {
    thresholdMet: trackerInfo.DSCSpend.find(
      (spend) => spend.statusDesc === Constant.CURRENT
    )?.thresholdMet
  };
};

export const getTrackerInfo = (
  trackerContent: StatusTrackerResponse,
  record: VisitRecord
) => {
  return trackerContent['dscSpendTracker']
    ? trackerContent.dscSpendTracker.find(
        (tracker) => tracker.affiliationId === record.affiliationId
      )
    : undefined;
};

export const getVisitName = (aem: VisitSpend, record: VisitRecord) => {
  return (
    aem.cardTile.find((tile) => tile.type === record.affiliationTypeCode)
      ?.title || record.affiliationTypeDesc
  );
};

export const isValidSkyClubMember = (profile: UserSession): boolean => {
  return (
    profile.isSkyClubMember === 'Y' &&
    profile.skyClubMembershipDiscontinueDate !== undefined
  );
};

export const getDescription = (aem: VisitSpend, profile: UserSession) => {
  return (
    aem.unlimited.Validity.replace(
      Constant.DATE,
      profile.skyClubMembershipDiscontinueDate
        ? formatDate(
            profile.skyClubMembershipDiscontinueDate,
            Constant.DATE_FORMAT,
            Constant.EN_US
          )
        : ''
    ) ?? ''
  );
};
